import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { maxDiscountText } from '../../../constants/constants';

export const MaxDiscountMessage = () => {
  return (
    <div className="-sui-mb-4">
      <Alert status="info">{maxDiscountText}</Alert>
    </div>
  );
};
